import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import '../../styles/TyPage.scss';
import logo from "../../assets/logo.png";
import FailedTransaction from './FailedTransaction'; 
import PageLoading from '../../components/PageLoading'; 

const API_ENDPOINT = process.env.REACT_APP_BD_API_ENDPOINT;
const APP_KEY = process.env.REACT_APP_BD_APP_KEY!;
const PUB_KEY = process.env.REACT_APP_BD_PUB!;
const API_SECRET = process.env.REACT_APP_BD_SECRET!;
const encodeCredentials = btoa(`${PUB_KEY}:${API_SECRET}`);

const TyPage = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const transactionId = params.get('transactionId');
  const [transaction, setTransaction] = useState<any>(null);
  const [loadingTransaction, setLoadingTransaction] = useState(true);


  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        const res = await fetch(`${API_ENDPOINT}/api/v2/transactions/${transactionId}`, {
          method: 'GET',
          headers: {
            'X-App': APP_KEY,
            'Authorization': `Bearer ${encodeCredentials}`,
            'Content-Type': 'application/json',
          },
        });
        const result = await res.json();
        const data = result.data;

       if (data && data.status === 'Succeeded') {
  setTransaction(data);

} else {
  setTransaction(null);
}

      } catch (err) {
        console.error('Failed to fetch transaction:', err);
      } finally {
        setLoadingTransaction(false);
      }
    };

    if (transactionId) {
      fetchTransaction();
    }
  }, [transactionId]);

  if (loadingTransaction) return <PageLoading />;
  if (!transaction) return <FailedTransaction />;

  return (
    <div className="ty-container">
      <div className="ty-content">
        <Link to="/">
        <img src={logo} alt="Logo" className="ty-logo" />
        </Link>

        <h2 className="ty-title">Thank you for your purchase!</h2>
        <p className="ty-subtext">
          You're all set!
          <br />
          Reference No.: <strong>{transactionId}</strong>
        </p>
        <p className="ty-confirmation">
          A confirmation has been sent to your email. See you!
        </p>

        <p className='ty-reminder'>
          Please make sure to download your ticket sent to your email.
        </p>
        {/* {transactionId && (
          <button
            onClick={() => downloadPDF(transactionId)}
            className="ty-button"
            disabled={loading}
          >
            {loading ? 'Generating PDF...' : 'Download Ticket'}
          </button>
        )} */}

        {/* <div className="ty-discover">
          <p className="ty-discover-title">Discover more with Gottit!</p>
          <p className="ty-discover-text">
            Sign up for free and explore exclusive products, offers, and more — only on Gottit
          </p>
          <a
            href="https://gottit.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="ty-button"
          >
            Go back to Gottix
          </a>
        </div> */}

        <div className="ty-discover">
          <Link to="/" className="ty-button">
            Go back to Gottix
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TyPage;
